import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import { ChargePointDto } from '../../domain/infra/chargePoint/chargePoint';
import { UserCableRequirement } from '../../domain/infra/plug/plugType';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {GhostComponent} from '../../utils/ghostComponent';

@Component({
    selector: 'charge-point-choice',
    templateUrl: './chargePointChoice.component.html',
    styleUrls: ['./chargePointChoice.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ChargePointChoiceComponent),
            multi: true
        }
    ]
})
export class ChargePointChoiceComponent extends GhostComponent implements ControlValueAccessor {
    private chargePoint: ChargePointDto;
    private onChange: (_: ChargePointDto) => void;
    private onTouched: () => void;

    @Input() public disabled: boolean = false;
    @Input() public displayMode: ('default' | 'minimal') = 'default';
    @Input() public itemActions: Array<ItemAction> = [];
    @Input() public chargePointIdWithPendingAction: string | undefined;
    @Input() public disabledAction: boolean;
    @Input() public chargePoints: Array<ChargePointDto>;

    @Output() public clickAction = new EventEmitter<ChargePointClickEvent>();

    isSelected(chargePointDto: ChargePointDto): boolean {
        return this.chargePoint === chargePointDto;
    }

    selectChargePoint(chargePointDto: ChargePointDto) {
        this.chargePoint = chargePointDto;
        this.onTouched();
        this.onChange(this.chargePoint);
    }

    isCableRequired(chargePoint: ChargePointDto) {
        return UserCableRequirement.REQUIRED === chargePoint.userCableRequirement;
    }

    canUseOneItemActions( chargePoint: ChargePointDto): boolean {
        return !!this.itemActions.find(itemAction => itemAction.canUse(chargePoint));
    }

    public registerOnChange(onChange: (_: ChargePointDto) => void): void {
        this.onChange = onChange;
    }

    public registerOnTouched(onTouched: () => void): void {
        this.onTouched = onTouched;
    }

    public setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    public writeValue(value: ChargePointDto): void {
        this.chargePoint = value;
    }

    doAction(actionName: string, chargePoint: ChargePointDto) {
        this.clickAction.emit({actionName, chargePoint});
    }

    public generateGhost(): void {
    }

    trackById(index: number, chargePoint: ChargePointDto) {
        return chargePoint.id;
    }

    trackByActionName(index: number, itemAction: ItemAction) {
        return itemAction ? itemAction.actionName : null;
    }
}

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type ItemAction = { actionName: string, icon: string, canUse: (ChargePointDto) => boolean };

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type ChargePointClickEvent = { actionName: string, chargePoint: ChargePointDto };
